export default __webpack_public_path__ + "static/media/item_10.f2b65b1a.png";